export const REQUEST_REVERSE_RESOLVER = 'REQUEST_REVERSE_RESOLVER';
export const RECEIVE_REVERSE_RESOLVER = 'RECEIVE_REVERSE_RESOLVER';
export const ERROR_REVERSE_RESOLVER = 'ERROR_REVERSE_RESOLVER';

export const REQUEST_SET_REVERSE_RESOLVER = 'REQUEST_SET_REVERSE_RESOLVER';
export const WAITING_SET_REVERSE_RESOLVER = 'WAITING_SET_REVERSE_RESOLVER';
export const RECEIVE_SET_REVERSE_RESOLVER = 'RECEIVE_SET_REVERSE_RESOLVER';
export const ERROR_SET_REVERSE_RESOLVER = 'ERROR_SET_REVERSE_RESOLVER';

export const CLOSE_SET_REVERSE_RESOLVER = 'CLOSE_SET_REVERSE_RESOLVER';
